export default function formatMinutes(value) {
  if (Number.isNaN(value)) {
    console.log('FormatMinutesPipe received a value that is not a number: ', value);
    return '--';
  }

  const hours = Math.floor(value / 60);
  const minutes = value - (hours * 60);

  if (!minutes) {
    return `${hours}hr`;
  }
  if (!hours) {
    return `${minutes}min`;
  }

  return `${hours}hr ${minutes}min`;
}
